<template>
    <div class="search_wrap">
        <el-date-picker
            v-if="['pass', 'reject', 'report'].includes(page)"
            v-model="date"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            class="mr15"
        ></el-date-picker>
        
        <el-input v-if="['stay', 'pass', 'reject'].includes(page)" size="small" v-model="keyword" placeholder="素材标题/素材链接/审核ID" class="input_class mr15"></el-input>
    
        <el-select
            v-if="['report'].includes(page)"
            v-model="collection"
            filterable
            collapse-tags
            multiple
            clearable
            placeholder="代码位合集"
            class="select_class mr15"
            size="small"
        >
            <el-option
                v-for="item in collectionList"
                :key="item.id"
                :label="item.collection_name"
                :value="item.id">
            </el-option>
        </el-select>
        
        <el-select
            v-model="adSlot"
            filterable
            collapse-tags
            multiple
            clearable
            placeholder="代码位"
            class="select_class mr15"
            size="small"
        >
            <el-option
                v-for="item in adSlotList"
                :key="item.id"
                :label="item.id + ' ' + item.name"
                :value="item.id">
            </el-option>
        </el-select>
        
        <el-select
            v-if="['stay', 'pass', 'reject'].includes(page)"
            v-model="materialType"
            clearable
            placeholder="素材类型"
            size="small"
            class="select_class mr15"
        >
            <el-option
                v-for="item in materialTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
        </el-select>
      
        <el-select
          v-if="['stay', 'pass', 'reject'].includes(page)"
          v-model="os"
          clearable
          placeholder="操作系统"
          size="small"
          class="select_class mr15"
        >
          <el-option
            v-for="item in osList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        
        <el-button type="primary" size="small" @click="handleSearchSubmit">查询</el-button>
    </div>
</template>

<script>
// import { getCommonDict } from '@/apis/common';
import { getPreviewCollectionList, getPreviewCollectionAdslotList } from '@/apis/advCenter.js';
import { getDate } from '@/common/utils';

export default {
    name: 'audit-search',
    data() {
        return {
            date: '',
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > new Date().getTime();
                }
            },
            keyword: '',
    
            collectionList: [],
            collection: [],
            
            adSlotList: [],
            adSlot: [],
    
            materialTypeList: [],
            materialType: '',
          
            osList: [
              { label: 'Android', value: 2 },
              { label: 'iOS', value: 5 },
              { label: '通投', value: 0 }
            ],
            os: '',
        }
    },
    
    props: {
        page: String
    },
    
    methods: {
        init() {
            if (['pass', 'reject'].includes(this.page)) {
                this.date = [getDate(), getDate()];
            }
            if (['report'].includes(this.page)) {
                this.date = [getDate(-7), getDate()];
            }
            this.common();
            this.getGroupList();
            this.getAdSlotList();
        },
        
        // 素材类型
        async common() {
            if (['report'].includes(this.page)) return;
            // const {code, data} = await getCommonDict({ type: 'adslot_idea_type' });
            // if (code && code === 200) {
            //     this.materialTypeList = data.options;
            // }
            this.materialTypeList = [
                { label: '图片', value: 1 },
                { label: '视频', value: 2 }
            ];
        },
        
        // 代码位合集列表
        async getGroupList() {
            if (!['report'].includes(this.page)) return;
            const {code, data} = await getPreviewCollectionList({ all: true });
            if (code && code === 200) {
                this.collectionList = data.list;
            }
        },
    
        // 代码位列表
        async getAdSlotList() {
            let params = {
                type: 'bind',
                page_size: 9999
            };
            const {code, data} = await getPreviewCollectionAdslotList(params);
            if (code && code === 200) {
                this.adSlotList = data.list;
            }
        },
        
        // 确认搜索
        handleSearchSubmit() {
            this.$emit('callback', {
                date: this.date,
                keyword: this.keyword,
                collection: this.collection,
                adSlotId: this.adSlot,
                materialType: this.materialType,
                os: this.os
            });
        }
    },
    
    mounted() {
        this.init();
    }
}
</script>
<style lang="scss">
.el-tag.el-tag--info{max-width: 150px;}
</style>
<style lang="scss" scoped>
.search_wrap{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    & .mr15{margin-right: 15px;}
    & .input_class{
        width: 200px;
    }
    & .select_class{
        width: 240px;
    }
}
</style>
